import React, { useEffect } from "react";
import { message, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { autenticado } from "shared/helpers/auth-functions";

const AguardandoLogin: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    // If already authenticated, redirect immediately
    if (autenticado()) {
      history.push("/");
      return;
    }
    const interval = setInterval(() => {
      message.loading("Aguardando autenticação...");
      message.loading(`token: ${localStorage.getItem("token")}`);
      if (autenticado()) {
        clearInterval(interval);
        history.push("/");
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [history]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "#26272c",
      }}
    >
      <Spin
        indicator={
          <LoadingOutlined style={{ fontSize: 48, color: "#fff" }} spin />
        }
      />
      <div style={{ marginTop: 24 }}>
        <Typography.Title level={3} style={{ color: "#fff" }}>
          Aguarde...
        </Typography.Title>
      </div>
    </div>
  );
};

export default AguardandoLogin;
